import React from 'react'
import Hero from './components/hero/Hero';
import Project from './components/Project';
import Contact from './components/contact/Contact';
import Aboutme from './components/Aboutme';
import styled from 'styled-components';
const Home = () => {
 

  return (
<>
<Mouse>


<Hero/>
   {/* <Me/>
   <About/>*/}
<Aboutme/>
<Project/> 
<Contact/>

</Mouse>
</>
  )
}
const Mouse = styled.div`
 

`

export default Home